// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c385733d","389":"88ea50ad","455":"b8339c9b","857":"c78b0d18","977":"4c4c3c6d"}[chunkId] + ".chunk.js";
};